import {railStates} from './../../../ukrail/ukrail-routes';

export default function UkRailHeaderBaseController(
    $scope,
    $state,
    $stateParams,
    $rootScope,
    railsFactory,
    userService,
    l10nService,
    baseEvents,
    railsUtils,
    timeService,
    railAmendmentService,
) {
    'ngInject';

    const regionalSettings = userService.getRegionalSettings();

    $scope.module = railsFactory.getModule();
    $scope.isUkRail = railsFactory.isUkRail();
    $scope.labels = railsFactory.getLabels();
    $scope.options = railsFactory.options;
    $scope.params = railsFactory.params;
    $scope.tempParams = angular.copy(railsFactory.params);
    $scope.params.Travelers.Child = {value: 0};
    $scope.isRebook = railAmendmentService.isAmendmentMode();

    // Format departure and return date
    const convertedDepartureDate = timeService.getDateInUserRegionFormatOrCurrentDate(
        $scope.params.RailTicketSearchSegments[0]._date
    );
    let convertedReturnDate = timeService.getDateInUserRegionFormatOrCurrentDate(
        $scope.params.RailTicketSearchSegments[0]._date);

    if (railsUtils.isRoundTripOrMultiTripFlight($scope.params.flightType)) {
        convertedReturnDate
            = timeService.getDateInUserRegionFormat($scope.params.RailTicketSearchSegments[1]._date)
                .format(regionalSettings.mediumDayMonthDateFormat);
    }

    $scope.rails = railsFactory.getFlights();

    if (_.isEmpty($scope.rails)) {
        return $state.go('main.' + railsFactory.getModule() + '.roundtrip');
    }

    /**
     * Set page Heading for mobile
     */
    initHeading();

    $scope.headerAll = {
        Total: $scope.rails.Total,
        TotalPassengerCount: +$scope.params.Travelers.Adult.value + +$scope.params.Travelers.Child.value,
        convertedDepartureDate,
        convertedReturnDate,
        route: railsUtils.calculateRoute($scope.params.RailTicketSearchSegments, $scope.params.flightType),
        dates: railsUtils.calculateDates($scope.params.RailTicketSearchSegments, $scope.params.flightType, $scope.params.isOpenReturn),
    };

    const initialDepartDate = timeService.getDateInUserRegionFormatOrCurrentDate(
        $scope.params.RailTicketSearchSegments[0]._date);
    const initialReturnDate = timeService.getDateInUserRegionFormatOrCurrentDate(
        $scope.params.RailTicketSearchSegments[1]._date);

    $scope.dateOptions = {
        optionsDepart: {
            placeholder: l10nService.localize('Depart date'),
            required: true,
            months: 2,
            start: initialDepartDate,
            after: moment().add({days: -1}),
            before: railsFactory.getMaxBookDate(),
            dependentPikers: ['dateOptions.optionsReturn'],
        },
        optionsReturn: {
            placeholder: l10nService.localize('Return date'),
            required: true,
            months: 2,
            start: initialReturnDate,
            before: railsFactory.getMaxBookDate(),
            after: moment(initialDepartDate).add({days: -1}),
        },
    };

    // Header is collapsed initially
    $scope.showHeader = true;

    $scope.disableOpenReturn = false;

    /**
     * Restore form when header closed
     */
    $scope.$watch('showHeader', function(newValue) {
        if (newValue) {
            $scope.tempParams = angular.copy($scope.params);
            $scope.dateOptions.optionsReturn.after = moment(initialDepartDate).add({days: -1});
        }
    });

    /**
     * Reset return date if earlier then departure date
     */
    $scope.$watch('tempParams.RailTicketSearchSegments[0]._date', resetDateIfEarlierThanDeparture);
    $scope.$watch('rails.FilteredTotal', initHeading);

    $scope.edit = edit;
    //$scope.toggleFiltersFlight = toggleFiltersFlight;
    $scope.findFlights = findFlights;

    $scope.$watch('tempParams.RailTicketSearchSegments[0]._departure', stationsWatcher);
    $scope.$watch('tempParams.RailTicketSearchSegments[0]._arrival', stationsWatcher);

    function stationsWatcher() {
        if ($scope.tempParams.RailTicketSearchSegments[0]._departure && $scope.tempParams.RailTicketSearchSegments[0]._departure.Code.startsWith('urn:')
            || $scope.tempParams.RailTicketSearchSegments[0]._arrival && $scope.tempParams.RailTicketSearchSegments[0]._arrival.Code.startsWith('urn:')) {
            $scope.tempParams.isOpenReturn = false;
            $scope.disableOpenReturn = true;
        } else {
            $scope.disableOpenReturn = false;
        }
    }

    function resetDateIfEarlierThanDeparture() {
        if ($scope.tempParams.flightType === 'roundtrip') {
            const departDate = moment(
                $scope.tempParams.RailTicketSearchSegments[0]._date,
                regionalSettings.dateFormat
            );
            const returnDate = moment(
                $scope.tempParams.RailTicketSearchSegments[1]._date,
                regionalSettings.dateFormat
            );
            if (departDate.isAfter(returnDate)) {
                $scope.dateOptions.optionsReturn.update('');
            }
            if ($scope.tempParams.isOpenReturn) {
                if (angular.isUndefined($scope.tempParams.RailTicketSearchSegments[1].RHour)) {
                    $scope.tempParams.RailTicketSearchSegments[1].RHour = {Text: '09', Value: '9'};
                    $scope.tempParams.RailTicketSearchSegments[1].RMinutes = {Text: '00', Value: '0'};
                }
            }
        }
    }

    /**
     * Perform search and go to results page
     */
    function findFlights() {
        railsFactory.findFlights($scope.tempParams)
            .then((data) => $state.go(data.EuropeanRails ? railStates.EUROPEANRESULTS : railStates.RESULTS, $stateParams, {reload: true}));
    }

    $scope.validateFromToStations = function(ctrl, controlName) { // eslint-disable-line
        if (controlName === '_address01') {
            ctrl.railsSearch._address01.$error.InvalidFromStation = false;
            ctrl.railsSearch._address01.$setValidity('InvalidFromStation', true);
            ctrl.railsSearch._address02.$error.InvalidToStation = false;
            ctrl.railsSearch._address02.$setValidity('InvalidToStation', true);
            ctrl.railsSearch.$valid = true;
            //ctrl.railsSearch._address02.$setValidity('InvalidToStation', true);
            if ($scope.tempParams.RailTicketSearchSegments[0]._departure && $scope.tempParams.RailTicketSearchSegments[0]._arrival && $scope.tempParams.RailTicketSearchSegments[0]._departure.Code === $scope.tempParams.RailTicketSearchSegments[0]._arrival.Code) {
                ctrl.railsSearch._address01.$error.InvalidFromStation = true;
                ctrl.railsSearch._address01.$setValidity('InvalidFromStation', false);
                ctrl.railsSearch.$valid = false;
                //params.RailTicketSearchSegments[0]._arrival.$setValidity('InvalidToStation', false);
            }
            if (angular.isDefined($scope.tempParams.GoViaOrAvoidRailStation)) {
                if ($scope.tempParams.RailTicketSearchSegments[0]._departure && $scope.tempParams.RailTicketSearchSegments[0]._departure.Code === $scope.tempParams.GoViaOrAvoidRailStation.Code
                    || $scope.tempParams.RailTicketSearchSegments[0]._arrival && $scope.tempParams.RailTicketSearchSegments[0]._arrival.Code === $scope.tempParams.GoViaOrAvoidRailStation.Code) {
                    ctrl.railsSearch._address01.$error.InvalidFromStation = true;
                    ctrl.railsSearch._address01.$setValidity('InvalidFromStation', false);
                    ctrl.railsSearch.$valid = false;
                }
            }
        } else if (controlName === '_address02') {
            ctrl.railsSearch._address01.$error.InvalidFromStation = false;
            ctrl.railsSearch._address01.$setValidity('InvalidFromStation', true);
            ctrl.railsSearch._address02.$error.InvalidToStation = false;
            ctrl.railsSearch._address02.$setValidity('InvalidToStation', true);
            ctrl.railsSearch.$valid = true;
            //ctrl.railsSearch._address02.$setValidity('InvalidToStation', true);
            if ($scope.tempParams.RailTicketSearchSegments[0]._arrival && $scope.tempParams.RailTicketSearchSegments[0]._departure && $scope.tempParams.RailTicketSearchSegments[0]._departure.Code === $scope.tempParams.RailTicketSearchSegments[0]._arrival.Code) {
                ctrl.railsSearch._address02.$error.InvalidToStation = true;
                ctrl.railsSearch._address02.$setValidity('InvalidToStation', false);
                ctrl.railsSearch.$valid = false;
                //params.RailTicketSearchSegments[0]._arrival.$setValidity('InvalidToStation', false);
            }
            if (angular.isDefined($scope.tempParams.GoViaOrAvoidRailStation)) {
                if ($scope.tempParams.RailTicketSearchSegments[0]._departure && $scope.tempParams.RailTicketSearchSegments[0]._departure.Code === $scope.tempParams.GoViaOrAvoidRailStation.Code
                    || $scope.tempParams.RailTicketSearchSegments[0]._arrival && $scope.tempParams.RailTicketSearchSegments[0]._arrival.Code === $scope.tempParams.GoViaOrAvoidRailStation.Code) {
                    ctrl.railsSearch._address02.$error.InvalidToStation = true;
                    ctrl.railsSearch._address02.$setValidity('InvalidToStation', false);
                    ctrl.railsSearch.$valid = false;
                }
            }
        }
    };

    /**
     * Toggle edit query form
     */
    function edit() {
        if (railsUtils.isMultiTripFlight($scope.params.flightType)) {
            $state.go('main.flights.multitrip');
        } else {
            $scope.showHeader = !$scope.showHeader;
        }
    }

    function initHeading() {
        $rootScope.pageHeading = l10nService.localize('Rail search');
    }

}



// WEBPACK FOOTER //
// ./src/app/modules/base/controllers/ukrail/railHeaderBaseCtrl.js